/**
 * The box editor's tabs, in the strip's order: the drop table (where the work is), the box's
 * details, its art (six image slots), and the storefront preview. A page may add its own after these (a box template's
 * Tenants). The tab rides the URL (`?tab=`), so a link can open the editor on a tab.
 */
export const BOX_EDITOR_TABS = ["drop-table", "details", "art", "preview"] as const;
export type BoxEditorTab = (typeof BOX_EDITOR_TABS)[number];

export const BOX_EDITOR_TAB_LABELS: Record<BoxEditorTab, string> = {
  "drop-table": "Drop table",
  details: "Details",
  art: "Art",
  preview: "Preview",
};

export interface BoxEditorSearch {
  /** One of `BOX_EDITOR_TABS`, or a tab the page adds; the layout drops one it does not know. */
  tab?: string;
}

/** The routes' `validateSearch`: any string is kept, since pages add their own tabs. */
export function parseBoxEditorSearch(search: Record<string, unknown>): BoxEditorSearch {
  return { tab: typeof search.tab === "string" && search.tab !== "" ? search.tab : undefined };
}

/** The tab to show: the requested one when the editor has it, else the drop table. */
export function resolveBoxEditorTab(requested: string | undefined, extra: string[]): string {
  const known = [...BOX_EDITOR_TABS, ...extra];
  return requested !== undefined && known.includes(requested) ? requested : "drop-table";
}
